import { motion } from 'framer-motion';
import type { PendingMessage } from './types';

interface PendingMessageBubbleProps {
  message: PendingMessage;
  onRetry: (message: PendingMessage) => void;
  onDismiss: (messageId: string) => void;
}

export function PendingMessageBubble({
  message,
  onRetry,
  onDismiss,
}: PendingMessageBubbleProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex justify-end"
    >
      <div className="max-w-[75%]">
        <div
          className={`px-4 py-2 rounded-2xl rounded-br-md ${
            message.status === 'failed'
              ? 'bg-red-100 border border-red-300'
              : 'bg-primary-950 text-white'
          }`}
        >
          <p
            className={`whitespace-pre-wrap break-words ${
              message.status === 'failed' ? 'text-red-800' : ''
            }`}
          >
            {message.content}
          </p>
          <div
            className={`text-xs mt-1 flex items-center gap-2 ${
              message.status === 'failed' ? 'text-red-600' : 'text-primary-200'
            }`}
          >
            {message.status === 'sending' ? (
              <span className="flex items-center gap-1">
                <span className="w-2 h-2 bg-current rounded-full animate-pulse" />
                Sending...
              </span>
            ) : (
              <span className="flex items-center gap-2">
                Failed to send
                <button
                  onClick={() => onRetry(message)}
                  className="underline hover:no-underline font-medium"
                >
                  Retry
                </button>
                <button
                  onClick={() => onDismiss(message.id)}
                  className="underline hover:no-underline"
                >
                  Dismiss
                </button>
              </span>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
}

